module.exports = __webpack_public_path__ + "img/gLogo.87bb3083.png";